import { MouseEvent } from 'react';
import { Label, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useConfig } from '../../providers';
import { widgetTypeState, widgetTypes } from '../../states';
import { RoutesName } from '../../states/constants';
import {
  ButtonWrapper,
  IconBox,
  SelectionStyles,
  SelectionButtonsContainer,
} from './Styles';

export const ModalSelection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isDesktop } = useDeviceSize();
  const { registeredBiometries } = useConfig();

  const setWidgetType = useSetRecoilState(widgetTypeState);

  if (!registeredBiometries.length) {
    return <Navigate to={RoutesName.configuration} replace />;
  }

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setWidgetType(event.currentTarget.id as widgetTypes);
    navigate(RoutesName.widget, {
      state: { ...(state as object), fromSelection: true },
    });
  };

  return (
    <SelectionStyles
      flexDirection="column"
      rowGap="1.5"
      justifyContent="center"
    >
      <Label
        fontSize={isDesktop ? '32' : '24'}
        textAlign="center"
        semibold
        testId="biometry_selector_title"
      >
        {t('How do you prefer to identify yourself?')}
      </Label>
      <SelectionButtonsContainer columnGap="3" justifyContent="center">
        <ButtonWrapper
          onClick={handleClick}
          id={widgetTypes.facial}
          data-test="biometry_selector_face_option_button"
        >
          <IconBox
            color="primary"
            size="XL"
            testId="face-selection"
            iconName="UserFocus"
            invertBackground={true}
          />
          <Label fontSize={isDesktop ? '16' : '12'} textAlign="center" semibold>
            {t('Face')}
          </Label>
        </ButtonWrapper>
        <ButtonWrapper
          onClick={handleClick}
          id={widgetTypes.vocal}
          data-test="biometry_selector_face_voice_button"
        >
          <IconBox
            size="XL"
            testId="voice-selection"
            color="primary"
            iconName="Microphone"
            invertBackground={true}
          />
          <Label fontSize={isDesktop ? '16' : '12'} textAlign="center" semibold>
            {t('Voice')}
          </Label>
        </ButtonWrapper>
      </SelectionButtonsContainer>
      <Label fontSize="16" textAlign="center" testId="biometry_selector_text">
        {t('You can add more options from your Settings panel')}
      </Label>
    </SelectionStyles>
  );
};
